import classNames from 'classnames';
import { IconButton, IIconButtonProps } from 'components/buttons/IconButton';

interface IMappingRowExpandIconProps extends Omit<IIconButtonProps, 'iconClassName'> {
  showIcon?: boolean;
  open?: boolean;
}

const getIconClassName = (open = false) =>
  classNames('dp-flow-mapping-row__icon', {
    'dp-flow-mapping-row__icon--collapse': !open,
    'dp-flow-mapping-row__icon--expand': open,
  });

const getIconContainerClassName = (showIcon = false) =>
  classNames({
    'dp-flow-mapping-row__icon-container': !showIcon,
  });

export function MappingRowExpandIcon({ showIcon, onClick, open }: IMappingRowExpandIconProps) {
  return (
    <IconButton
      onClick={onClick}
      className={getIconContainerClassName(showIcon)}
      iconClassName={getIconClassName(open)}
      iconSize={'small'}
    />
  );
}
